import crypto from 'crypto'
import { RiskMaperEnum } from 'views/InhouseGame/Plinko/components/GameBoard/config'
import { calProbFromHash, HASH_HEX_LENGTH } from './baseFairnessResult'

const pascalTriangle = [
  [1, 9, 37, 93, 163, 219, 247, 255, 256],
  [1, 10, 46, 130, 256, 382, 466, 502, 511, 512],
  [1, 11, 56, 176, 386, 638, 848, 968, 1013, 1023, 1024],
  [1, 12, 67, 232, 562, 1024, 1486, 1816, 1981, 2036, 2047, 2048],
  [1, 13, 79, 299, 794, 1586, 2510, 3302, 3797, 4017, 4083, 4095, 4096],
  [1, 14, 92, 378, 1093, 2380, 4096, 5812, 7099, 7814, 8100, 8178, 8191, 8192],
  [1, 15, 106, 470, 1471, 3473, 6476, 9908, 12911, 14913, 15914, 16278, 16369, 16383, 16384],
  [1, 16, 121, 576, 1941, 4944, 9949, 16384, 22819, 27824, 30827, 32192, 32647, 32752, 32767, 32768],
  [1, 17, 137, 697, 2517, 6885, 14893, 26333, 39203, 50643, 58651, 63019, 64839, 65399, 65519, 65535, 65536],
]

const payoutValues = [
  [
    [5.6, 2.1, 1.1, 1, 0.5, 1, 1.1, 2.1, 5.6],
    [13, 3, 1.3, 0.7, 0.4, 0.7, 1.3, 3, 13],
    [29, 4, 1.5, 0.3, 0.2, 0.3, 1.5, 4, 29],
  ],
  [
    [5.6, 2, 1.6, 1, 0.7, 0.7, 1, 1.6, 2, 5.6],
    [18, 4, 1.7, 0.9, 0.5, 0.5, 0.9, 1.7, 4, 18],
    [43, 7, 2, 0.6, 0.2, 0.2, 0.6, 2, 7, 43],
  ],
  [
    [8.9, 3, 1.4, 1.1, 1, 0.5, 1, 1.1, 1.4, 3, 8.9],
    [22, 5, 2, 1.4, 0.6, 0.4, 0.6, 1.4, 2, 5, 22],
    [76, 10, 3, 0.9, 0.3, 0.2, 0.3, 0.9, 3, 10, 76],
  ],
  [
    [8.4, 3, 1.9, 1.3, 1, 0.7, 0.7, 1, 1.3, 1.9, 3, 8.4],
    [24, 6, 3, 1.8, 0.7, 0.5, 0.5, 0.7, 1.8, 3, 6, 24],
    [120, 14, 5.2, 1.4, 0.4, 0.2, 0.2, 0.4, 1.4, 5.2, 14, 120],
  ],
  [
    [10, 3, 1.6, 1.4, 1.1, 1, 0.5, 1, 1.1, 1.4, 1.6, 3, 10],
    [33, 11, 4, 2, 1.1, 0.6, 0.3, 0.6, 1.1, 2, 4, 11, 33],
    [170, 24, 8.1, 2, 0.7, 0.2, 0.2, 0.2, 0.7, 2, 8.1, 24, 170],
  ],
  [
    [8.1, 4, 3, 1.9, 1.2, 0.9, 0.7, 0.7, 0.9, 1.2, 1.9, 3, 4, 8.1],
    [43, 13, 6, 3, 1.3, 0.7, 0.4, 0.4, 0.7, 1.3, 3, 6, 13, 43],
    [260, 37, 11, 4, 1, 0.2, 0.2, 0.2, 0.2, 1, 4, 11, 37, 260],
  ],
  [
    [7.1, 4, 1.9, 1.4, 1.3, 1.1, 1, 0.5, 1, 1.1, 1.3, 1.4, 1.9, 4, 7.1],
    [58, 15, 7, 4, 1.9, 1, 0.5, 0.2, 0.5, 1, 1.9, 4, 7, 15, 58],
    [420, 56, 18, 5, 1.9, 0.3, 0.2, 0.2, 0.2, 0.3, 1.9, 5, 18, 56, 420],
  ],
  [
    [15, 8, 3, 2, 1.5, 1.1, 1, 0.7, 0.7, 1, 1.1, 1.5, 2, 3, 8, 15],
    [88, 18, 11, 5, 3, 1.3, 0.5, 0.3, 0.3, 0.5, 1.3, 3, 5, 11, 18, 88],
    [620, 83, 27, 8, 3, 0.5, 0.2, 0.2, 0.2, 0.2, 0.5, 3, 8, 27, 83, 620],
  ],
  [
    [16, 9, 2, 1.4, 1.4, 1.2, 1.1, 1, 0.5, 1, 1.1, 1.2, 1.4, 1.4, 2, 9, 16],
    [110, 41, 10, 5, 3, 1.5, 1, 0.5, 0.3, 0.5, 1, 1.5, 3, 5, 10, 41, 110],
    [1000, 130, 26, 9, 4, 2, 0.2, 0.2, 0.2, 0.2, 0.2, 2, 4, 9, 26, 130, 1000],
  ],
]

export function generatePlinkoFairResult(
  serverSeed: string,
  clientSeed: string,
  nonce: number,
  rowCount: number,
  risk: RiskMaperEnum,
) {
  const hash = generateHash(serverSeed, clientSeed, nonce, rowCount, risk)

  // prob is in [0, 1)
  const prob = calProbFromHash(hash, HASH_HEX_LENGTH)

  // convert prob from [0, 1) to [0, pascal_triangle_max(row_count))
  const dec = Math.floor(prob.toNumber() * 2 ** rowCount) // Use Math.floor as Go's int64 truncates

  const outcomeDataIndex = calculateOutcomeData(dec, rowCount - 8)
  const multiplier = payoutValues[rowCount - 8][risk][outcomeDataIndex]
  return multiplier
}

/**
 * Generates an HMAC SHA256 hash.
 * @param {string} serverSeed - The server seed.
 * @param {string} clientSeed - The client seed.
 * @param {number} nonce - The nonce value.
 * @param {number} rowCount - The number of rows.
 * @param {number} risk - The risk level.
 * @returns {string} The hexadecimal representation of the hash.
 */
function generateHash(
  serverSeed: string,
  clientSeed: string,
  nonce: number,
  rowCount: number,
  risk: RiskMaperEnum,
): string {
  const key = serverSeed // Node.js crypto module expects string or Buffer for key
  const message = `${clientSeed}:${nonce}:${rowCount}:${risk}`

  // Create an HMAC object using SHA256 algorithm and the serverSeed as the key
  const hmac = crypto.createHmac('sha256', key.toString())

  // Update the HMAC with the message
  hmac.update(message)

  // Get the hexadecimal digest of the HMAC
  return hmac.digest('hex')
}

/**
 * Calculates the outcome data based on the calculated decimal value and row index.
 * @param {number} dec - The decimal value derived from the probability.
 * @param {number} rowIndex - The index of the Pascal's Triangle row to use.
 * @returns {object} outcomeData - The Plinko result containing the index.
 */
function calculateOutcomeData(dec: number, rowIndex: number): number {
  const pascalTriangleRow = pascalTriangle[rowIndex]

  // Binary search to find the closest value to dec
  // JavaScript's Array.prototype.findIndex can be used or implement binary search manually
  let index = 0
  let low = 0
  let high = pascalTriangleRow.length - 1

  while (low <= high) {
    const mid = Math.floor((low + high) / 2)
    if (pascalTriangleRow[mid] > dec) {
      index = mid
      high = mid - 1
    } else {
      low = mid + 1
    }
  }

  // Check if the found index is out of bounds (original Go logic handles this by decrementing if it's the length)
  if (index === pascalTriangleRow.length && pascalTriangleRow.length > 0) {
    index--
  }

  return index
}
